module.exports = __webpack_public_path__ + "static/media/logo-light.fd1d3145.svg";